export default __webpack_public_path__ + "static/media/idea-icon.e16655f0.svg";